<template>
  <div class="wrapper-content w-100" id="decretos-movements">
    <h1>{{ titulo }}</h1>
    <LmComponentLoading v-if="isLoading" fixed />
    <div class="estado-decreto">
      <h2>{{subtitulo}}</h2>
      <a-timeline
        mode="alternate"
        v-if="movimientos.items.length"
      >
        <a-timeline-item
          v-for="(m, index) of movimientos.items"
          :key="index"
          :color="m.hidden_historial.color || 'gray'"
        >
          <a-icon
            v-if="m.hidden_historial.icon"
            slot="dot"
            :type="m.hidden_historial.icon"
            style="font-size: 22px;"
          />
          <div class="datos d-flex flex-column mx-2">
            <span class="accion" :style="{color: titleColor[m.hidden_historial.color]}">{{ m.estado }}</span>
            <span class="usuario">{{ m.responsable_confirmacion }}</span>
            <span class="oficina">{{ m.oficina_destino === '-'? m.oficina_origen : m.oficina_destino }}</span>
            <span>{{ m.fecha_movimiento }}</span>
          </div>
        </a-timeline-item>
      </a-timeline>
    </div>
    <hr>
    <LmButton
      id="btn-cancel"
      type="button"
      buttonClass="btn-secondary"
      :isProcessing="formIsProcessing"
      value="Volver"
      @click.native="goBackBtn"
      lmButtonRootWrapperClass="d-inline-block mr-1"
      lmButtonWrapperClass="col"
    />
  </div>
</template>

<script>
import commonsApi from '@/api/commons'
import moment from 'moment'
import LmButton from '@/components/form/elements/LmButton'

import 'moment/locale/es'
moment.locale('es')

export default {
  data () {
    return {
      titulo: 'Historial',
      decretoTitulo: 'Historial',
      isLoading: false,
      formIsProcessing: false,
      movimientos: {
        items: []
      },
      titleColor: {
        red: '#f5222d',
        gray: '#6c757d',
        green: '#52c41a',
        blue: '#1890ff',
        yellow: '#FFFF00'
      }
    }
  },
  components: {
    LmButton
  },
  methods: {
    goBackBtn () {
      this.$router.go(-1)
    }
  },
  watch: {
    movimientos: {
      handler (val, oldVal) {
        this.movimientos = val
        this.movimientos.items.forEach(i => (i.fecha = moment(i.fecha).format('DD-MM-YYYY HH:mm:ss')))
      }
    }
  },
  async created () {
    try {
      this.isLoading = true
      const movimientosPromise = commonsApi.axiosGetWrapper(`pases/delexpediente/?limit=100&id=${this.$route.params.id}&historial=1`)

      const tramitePromise = commonsApi.getItemDetail({
        path: 'expedientes/activos/edit/',
        id: this.$route.params.id
      })

      const [movimientosRes, tramiteRes] = await Promise.all([movimientosPromise, tramitePromise])

      this.movimientos = movimientosRes.data
      this.movimientos.items.reverse()
      this.titulo = `Trámite: ${tramiteRes.numeroExpediente}`
    } catch (error) {

    } finally {
      this.isLoading = false
    }
  }
}
</script>

<style lang="sass" scoped>
#decretos-movements
  .estado-decreto
    h2
      margin-bottom: 40px
    margin-top: 20px
    margin-bottom: 40px
    .datos
      .accion
        font-weight: bold
        text-transform: uppercase
      .usuario
        text-transform: lowercase
        font-weight: bold
      .usuario:first-letter
        text-transform: uppercase
      .oficina
        text-transform: lowercase
      .oficina:first-letter
        text-transform: uppercase
</style>
